import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const StyledEmphasisPopover = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  ${'' /* Fixed width to prevent layout shift */}
  width: ${(props) =>
    props.currentEmphasis === null ? 'fit-content' : '92px'};

  .emphasis-icon-container {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    background: ${COLOR.secondary[80]};
    cursor: pointer;
  }

  &.disabled {
    pointer-events: auto;
    cursor: not-allowed !important;
    background: transparent;
    opacity: 0.5;
  }
`;

const StyledPopoverHeader = styled('div')`
  padding: 4px 8px;
  border-bottom: 1px solid ${COLOR.indigo['16']};
  box-sizing: border-box;
  height: 48px;
  display: flex;
  align-items: center;
`;

const StyledPopoverContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`;

const StyledEmphasisController = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledEmphasisSlider = styled('div')`
  display: flex;
  padding: 2px 0px;
  gap: 16px;
  align-items: center;
`;

const StyledEmphasisAction = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0px 16px 16px 16px;
`;

export {
  StyledEmphasisPopover,
  StyledPopoverContent,
  StyledPopoverHeader,
  StyledEmphasisController,
  StyledEmphasisSlider,
  StyledEmphasisAction,
};
